import Vue from 'vue';
import Router from 'vue-router';
import Meta from 'vue-meta';

import AuthPage from '../pages/AuthPage.vue';
import ApplicationsPage from '../pages/ApplicationsPage.vue';

Vue.use(Router);
Vue.use(Meta, {
  keyName: 'metaInfo',
  attribute: 'data-vue-meta',
  ssrAttribute: 'data-vue-meta-server-rendered',
  tagIDKeyName: 'vmid',
});

const router = new Router({
  routes: [
    {
      path: '/auth',
      name: 'Auth',
      component: AuthPage,
    },

    {
      path: '/projects',
      name: 'Applications',
      component: ApplicationsPage,
    },

    {
      path: '*',
      redirect: 'auth',
    },
  ],

  mode: 'history',
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js